const KarhooTaxi = (state) => state.KarhooTaxi

export default {
  KarhooTaxi
}
